import { ChangeDetectionStrategy, Component, inject, Injector, Input, OnDestroy } from "@angular/core";
import { toolbarOptions } from "../../../shared/model/toolbar-constants";
import { Subscription } from "rxjs";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { MatDialog } from "@angular/material/dialog";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../../shared/model/google-analytics-constants";
import { FeatureFlagsService } from "../../services/internal-services/feature-flags.service";
import { FeatureFlags } from "../../model/feature-flags";
import { AddUserDataDialogComponent } from "../../../dialog-components/add-user-data-dialog/add-user-data-dialog.component";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-user-data",
  templateUrl: "./user-data.component.html",
  styleUrls: ["./user-data.component.scss"],
  standalone: false,
})
export class UserDataComponent implements OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  toolbarOption = toolbarOptions.USER_DATA_MANAGER;

  subscriptions: Subscription[] = [];

  displayPanel = false;

  private _enabledProperties: boolean = false;

  @Input() set enabledProperties(value: boolean) {
    this._enabledProperties = value;
  }

  @Input() set enabledTool(tool: string) {
    this.displayPanel = this.toolbarOption === tool;
  }

  get enabledProperties(): boolean {
    return this._enabledProperties;
  }

  constructor(
    protected googleAnalyticsService: GoogleAnalyticsService,
    private toolbarService: ToolbarService,
    private matDialog: MatDialog,
    protected flagService: FeatureFlagsService,
    public injector: Injector,
  ) {}

  FeatureFlags = FeatureFlags;

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  togglePanelDisplay() {
    this.toolbarService.enableTool(!this.displayPanel ? this.toolbarOption : toolbarOptions.NONE);
  }

  showUploadDialog() {
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.ADD_DATA_CLICK,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );
    const dialog = this.matDialog.open(AddUserDataDialogComponent, {
      data: {
        title: "Add user data",
        viewerService: this.viewerService,
      },
      panelClass: "medium-panel-dialog",
      injector: this.injector,
    });
    dialog.afterClosed().subscribe(() => {});
  }

  onShowUploadDialog($event: any) {
    this.showUploadDialog();
  }
}
